export { mdxPrism as default } from './mdxPrism';
export { MdxPrismOptions } from './types';
